var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 200,
    viewBox: "0 0 150 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.111 0H88.8889V73.3508L35.5889 20.0508L20.0507 35.5889L73.3508 88.889H0V111.111H73.3331L20.0087 164.436L35.5556 179.982L88.8889 126.649V200H111.111V126.649L164.448 179.986L179.986 164.448L126.649 111.111H200V88.889H126.649L179.946 35.5918L164.399 20.045L111.111 73.3332V0Z",
    fill: "#EBFF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.c001556c84f5233fdfe5a4d14b496c74.svg";
export { ForwardRef as ReactComponent };